<div class="lg-stage">

  <!-- theme toggle, top-right -->
  <button type="button" class="lg-theme" (click)="toggleTheme()"
          [title]="isDark() ? 'Mode terang' : 'Mode gelap'"
          [attr.aria-label]="isDark() ? 'Ganti ke mode terang' : 'Ganti ke mode gelap'">
    <svg *ngIf="!isDark()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z"/>
    </svg>
    <svg *ngIf="isDark()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4.5"/>
      <path d="M12 2v2.2M12 19.8V22M4.9 4.9l1.6 1.6M17.5 17.5l1.6 1.6M2 12h2.2M19.8 12H22M4.9 19.1l1.6-1.6M17.5 6.5l1.6-1.6"/>
    </svg>
  </button>

  <!-- decorative orbits: faint rings with slowly drifting satellites -->
  <div class="lg-orbits" aria-hidden="true">
    <svg viewBox="0 0 1200 1200" preserveAspectRatio="xMidYMid slice">
      <defs>
        <radialGradient id="lgGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="rgba(23,97,253,.10)"/>
          <stop offset="100%" stop-color="rgba(23,97,253,0)"/>
        </radialGradient>
      </defs>
      <circle cx="600" cy="600" r="430" fill="url(#lgGlow)"/>
      <g class="lg-ring lg-ring-1">
        <circle cx="600" cy="600" r="260" fill="none" stroke="rgba(23,97,253,.14)" stroke-width="1"/>
        <circle cx="860" cy="600" r="5" fill="#1761fd" opacity=".45"/>
      </g>
      <g class="lg-ring lg-ring-2">
        <circle cx="600" cy="600" r="380" fill="none" stroke="rgba(48,62,103,.10)" stroke-width="1"/>
        <circle cx="600" cy="220" r="4" fill="#7c8db5" opacity=".55"/>
      </g>
      <g class="lg-ring lg-ring-3">
        <circle cx="600" cy="600" r="520" fill="none" stroke="rgba(23,97,253,.08)" stroke-width="1"/>
        <circle cx="232" cy="380" r="3.5" fill="#1761fd" opacity=".35"/>
      </g>
    </svg>
  </div>

  <!-- login card -->
  <div class="lg-card">
    <img src="assets/images/hatam_logo.svg" alt="Hatam" class="lg-logo">
    <h1 class="lg-title">Dashboard Admin</h1>
    <p class="lg-sub">Kelola konten dan pengguna aplikasi Hatam.</p>

    <form [formGroup]="credentials" (ngSubmit)="login()" novalidate>
      <div class="lg-field">
        <label class="lg-label" for="username">Username</label>
        <input id="username" type="text" class="lg-input" [class.invalid]="isInvalid('username')"
               placeholder="Username" formControlName="username" autocomplete="username">
        <div class="lg-error" *ngIf="isInvalid('username')">Username wajib diisi.</div>
      </div>

      <div class="lg-field">
        <label class="lg-label" for="userpassword">Password</label>
        <div class="lg-pass">
          <input id="userpassword" [type]="showPass ? 'text' : 'password'" class="lg-input"
                 [class.invalid]="isInvalid('password')" placeholder="Password"
                 formControlName="password" autocomplete="current-password">
          <button type="button" class="lg-eye" (click)="showPass = !showPass"
                  [title]="showPass ? 'Sembunyikan password' : 'Lihat password'"
                  [attr.aria-label]="showPass ? 'Sembunyikan password' : 'Lihat password'">
            <svg *ngIf="!showPass" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            <svg *ngIf="showPass" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          </button>
        </div>
        <div class="lg-error" *ngIf="isInvalid('password')">Password wajib diisi.</div>
      </div>

      <div class="lg-alert" *ngIf="loginError" role="alert">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5h.01"/></svg>
        <span>{{loginError}}</span>
      </div>

      <button type="submit" class="lg-submit" [disabled]="isLoading">
        <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i>
        {{isLoading ? 'Memeriksa…' : 'Masuk'}}
      </button>
    </form>

    <p class="lg-foot">
      &copy; {{year}} Yayasan Hatam Hasanah Qur'an
      <span class="lg-ver">Versi 3.0</span>
    </p>
  </div>
</div>
